import React from 'react';
import { Link } from '../components/router/link';

import '../../css/datagrid.css';
import '../../css/react-select.css';
import '../../css/datepicker.css';
import '../../css/main.css';
import '../../css/react-redux-modal.css';

export default class LoginLayout extends React.Component {

	render () {
	    return(
	    	<div>
	    		<img id="login-bg" alt="" src={'static/img/login-bg.jpg'} />
		    	<div id="login" className="ui middle aligned center aligned grid">
					<div className="column">
		                {this.props.children}
		            </div>
		        </div>
				<Link pathname="register">
					<div className="ui orange circular label btn-register"><i className="add user icon"></i>Zarejestruj</div>
				</Link>
	        </div>
	    )
	}

}



/** WEBPACK FOOTER **
 ** ./js/layouts/LoginLayout.js
 **/